import { filter, findIndex, some } from 'lodash';
import { arrayMove } from '@dnd-kit/sortable';
import { getDateTime } from '@sda/utils/date';
import type { AnyAction } from '@reduxjs/toolkit';
import type { PublicImageUrl } from '@sda/interfaces/image';

export const UploadReducer = (state: PublicImageUrl[], action: AnyAction): PublicImageUrl[] => {
  switch (action.type) {
    case 'ADD_IMAGE': {
      const { image, multiple = true } = action;
      const { hash, path, id } = image;

      const hashExists = some(state, (item) => item.hash === hash);

      const uploadObject = {
        hash,
        path,
        id: id || hash,
        updatedAt: getDateTime().toJSDate(),
      };

      if (!multiple) {
        return [uploadObject];
      }

      if (hashExists) {
        return state;
      }

      return [
        ...state,
        uploadObject,
      ];
    }
    case 'REMOVE_IMAGE': {
      const { filePath } = action;

      return filter(state, (file) => file.path !== filePath);
    }
    case 'REORDER_IMAGE': {
      const { newId, oldId } = action;

      const oldIndex = findIndex(state, (item) => item.id === oldId);
      const newIndex = findIndex(state, (item) => item.id === newId);

      return arrayMove(state, oldIndex, newIndex);
    }
    case 'UPDATE_IMAGE_PATH': {
      const { image } = action;
      const { hash, path, updatedAt } = image;

      return state.map((item) => {
        if (item.hash === hash) {
          return {
            ...item,
            path,
            updatedAt,
          };
        }

        return item;
      });
    }
    default:
      return state;
  }
};
